import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseLarge = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 4L12 12M12 12L20 20M12 12L4 20M12 12L20 4",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCloseLarge;
